import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';
import { Tsk5030Class } from '../../Class/TSK5030/tsk5030-class';
// import { Tsk5011Class } from '../../Class/TSK5011/tsk5011-class';

@Injectable({
  providedIn: 'root'
})
export class Tsk5030Service {
  LoadFind(classobj: Tsk5030Class) {
    throw new Error("Method not implemented.");
  }

     baseUrl: string=environment.baseUrl + 'tsk5030/';
     constructor(private http:HttpClient) { }
   
 
   GetCommonControlNames(id):Observable<any>
   {
       return this.http.get<any>(this.baseUrl+'GetCommonControlNames/'+id);
   }
      GetControlNames():Observable<any>
   {
     return this.http.get<any>(this.baseUrl+'GetControlNames');
   }

  LoadDatas(classobj: Tsk5030Class):Observable<any>
  {
    return this.http.get<any>(this.baseUrl+'LoadDatas');
  }
  ApproveOrReject(classobj: Tsk5030Class):Observable<any>
  {
  
    return this.http.post<any>(this.baseUrl+'ApproveOrReject',classobj);
  }

   Post(Tsk5030Class:Tsk5030Class):Observable<any>
     {
       return this.http.post<any>(this.baseUrl+'Post',Tsk5030Class);
     }
 ApproveBulk(classobjList: Tsk5030Class): Observable<any> {
  return this.http.post<any>(this.baseUrl + 'ApproveBulk', classobjList);
}

 ChangeCompany(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'ChangeCompany/'+id);
}

  LoadControls():Observable<any>
  {
    return this.http.get<any>(this.baseUrl+'LoadControls');
  }


}
